import { createContext, useContext, useState, type ReactNode } from "react";

interface PendingTranscription {
  fileName: string;
  currentStep: "uploading" | "queued" | "processing" | "completed" | "error";
  progress: number;
  error?: string;
  id?: string;
  createdAt?: string;
  storagePath?: string;
}

interface RecordingStateContextType {
  isSilenceWarningVisible: boolean;
  setIsSilenceWarningVisible: (visible: boolean) => void;
  isRecordingPaused: boolean;
  setIsRecordingPaused: (paused: boolean) => void;
  pendingTranscription: PendingTranscription | null;
  setPendingTranscription: (transcription: PendingTranscription | null) => void;
  isArchiveMode: boolean;
  setIsArchiveMode: (isArchiveMode: boolean) => void;
}

const RecordingStateContext = createContext<RecordingStateContextType | null>(null);

export const RecordingStateProvider = ({ children }: { children: ReactNode }) => {
  const [isSilenceWarningVisible, setIsSilenceWarningVisible] = useState(false);
  const [isRecordingPaused, setIsRecordingPaused] = useState(false);
  const [pendingTranscription, setPendingTranscription] = useState<PendingTranscription | null>(null);
  const [isArchiveMode, setIsArchiveMode] = useState(false);

  return (
    <RecordingStateContext.Provider
      value={{ isSilenceWarningVisible, setIsSilenceWarningVisible, isRecordingPaused, setIsRecordingPaused, pendingTranscription, setPendingTranscription, isArchiveMode, setIsArchiveMode }}
    >
      {children}
    </RecordingStateContext.Provider>
  );
};

export const useRecordingState = () => {
  const context = useContext(RecordingStateContext);
  if (!context) {
    throw new Error("useRecordingState must be used within RecordingStateProvider");
  }
  return context;
};
